


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { TaskConfig } from './../type/TaskConfig';

@Component
export default class TaskForm extends Vue {
  // prop
  @Prop({ default: 'new' }) private status!: 'new' | 'set'
  @Prop({ default: () => ({
      id: null,
      title: '',
      tomato: 4,
      tomatoed: 0,
      isDone: false
    })
  }) private task!: TaskConfig

  // data
  inChecked: number = this.task.tomato
  taskTitle: string = this.task.title

  // computed

  get id(): number | undefined {
    return this.task.id || this.$store.state.taskList.length
  }

  get tomato() {
    return this.$store.state.tomato
  }

  get formTypeClass() {
    if(this.status === 'new') return
    return `form--${this.status}`
  }

  saveChangeHandler() {
    if(!this.taskTitle) return
    const taskChange: {id: number | undefined ,inChecked: number, taskTitle: string} = {
      id: this.id,
      inChecked: this.inChecked,
      taskTitle: this.taskTitle
    }
    this.$store.commit('SAVE_TASK', taskChange)
  }

  addTaskHandler() {
    if(!this.taskTitle) return
    const taskChange: {id: number | undefined ,inChecked: number, taskTitle: string} = {
      id: this.id,
      inChecked: this.inChecked,
      taskTitle: this.taskTitle
    }
    if(this.status === 'new') {
      this.inChecked = 4
      this.taskTitle = ''
    }
    this.$store.commit('SAVE_TASK', taskChange)
  }
} 
